export default {
  // グラフデータ(type=plant)の追加用
  setGraphDialogFlag (state: {[key: string]: any}, flag: boolean) {
    state.graphDialogFlag = flag
  },
  // 画像表示用
  setImgFlag (state: {[key: string]: any}, flag: boolean) {
    state.imgFlag = flag
  },
  // メイン画像表示用
  setMainImgFlag (state: {[key: string]: any}, flag: boolean) {
    state.mainImgFlag = flag
  },
  // 右側生育状況用
  setSensorDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.sensorDataFlag = flag
  },
  // 右側生育(水遵守率)用
  setWaterComplianceRateFlag (state: {[key: string]: any}, flag: boolean) {
    state.waterComplianceRateFlag = flag
  },
  // fieldでの絞り込みセレクトボックス作成用
  setSelectDataListFlag (state: {[key: string]: any}, flag: boolean) {
    state.selectDataListFlag = flag
  },
  // mypageでの絞り込みセレクトボックス作成用
  setMySelectDataListFlag (state: {[key: string]: any}, flag: boolean) {
    state.mySelectDataListFlag = flag
  },
  // mypageでlocalStrageに絞り込みセレクトボックスデータがない時用
  setMyFieldDataApiFlag (state: {[key: string]: any}, flag: boolean) {
    state.myFieldDataApiFlag = flag
  },
  // mypageで外部API呼んでる時用
  setMyApiKeyFlag (state: {[key: string]: any}, flag: boolean) {
    state.myApiKeyFlag = flag
  },
  // 一覧の詳細データ用
  setFieldDetailsDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.fieldDetailsDataFlag = flag
  },
  // 一覧の詳細データ用
  setFieldModalDetailsFlag (state: {[key: string]: any}, flag: boolean) {
    state.fieldModalDetailsFlag = flag
  },
  // グラフマスターデータ用
  setGraphMasterDataFlag (state: {[key: string]: any}, flag: boolean) {
    state.graphMasterDataFlag = flag
  },
  // 実績グラフデータ用
  setGraphActualDataFlag (state: {[key:string]: boolean}, flag: boolean) {
    state.graphActualDataFlag = flag
  },
  setPlantingIdFlag (state: {[key: string]: any}, flag: boolean) {
    state.setPlantingIdFlag = flag
  },
  setGraphChangeDisplayYear (state: {[key: string]: any}, flag: boolean) {
    state.graphChangeDisplayYear = flag
  },
  setGrowthDialogFlag (state: {[key: string]: any}, flag: boolean) {
    state.growthDialogFlag = flag
  },
  setComparisonPlantFlag (state: {[key: string]: any}, flag: boolean) {
    state.comparisonPlantFlag = flag
  },
  setComparisonMasterFlag (state: {[key: string]: any}, flag: boolean) {
    state.comparisonMasterFlag = flag
  },
  setOpenSettingModalFlag (state: {[key: string]: any}, flag: boolean) {
    state.openSettingModalFlag = flag
  }
}
